<template>
  <div
    @mousedown="onMouseDown"
    @mouseup="onMouseUp"
    class="musicBox"
  >
    <div class="musicImage" ref="rotate1" v-drag>
      <img class="song-img" ref="rotate" src="../eiuov-ui/_ei-header/音乐12.png">
      <audio
        ref="audio"
        id="audio_music"
        autoplay="autoplay"
        @ended="playMusic()"
        @play="playSt()"
        @pause="pauseSt()"
        muted="muted"
        preload="auto"
      ></audio>
    </div>
  </div>
</template>

<script>
import { queryOneMusic } from "@/api/reception/works-api";

export default {
  name: "EiMusic",
  props: {
    isFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      pp: true,
      audio: {
        playing: true
      },
      musicAttach: {},
      oneMusic: {},
      startIndex: 1,
      // 新增：用于区分点击与拖动
      downX: 0,
      downY: 0,
      downTime: 0,
    }
  },
  watch: {

  },
  mounted() {
    queryOneMusic({}).then((res) => {
      if (!res)
        return
      this.musicAttach = res.data.music
      this.$refs.audio.src = this.musicAttach[0].url
    });
    this.playSt();
  },
  methods: {
    // 鼠标按下：记录起始坐标与时间
    onMouseDown(e) {
      this.downX = e.clientX;
      this.downY = e.clientY;
      this.downTime = Date.now();
    },
    // 鼠标松开：只有位移很小且时间很短时，才视为"点击"
    onMouseUp(e) {
      const dx = Math.abs(e.clientX - this.downX);
      const dy = Math.abs(e.clientY - this.downY);
      const dt = Date.now() - this.downTime;
      // 位移小于 5px 且时间小于 300ms，才认为是点击，否则视为拖动
      if (dx < 5 && dy < 5 && dt < 300) {
        this.playorOrpauseMusic();
      }
    },
    playSt() {
      this.$refs.rotate.style.animationPlayState = 'running';
      this.$refs.rotate1.style.animationPlayState = 'running';
    },
    pauseSt() {
      this.$refs.rotate.style.animationPlayState = 'paused';
      this.$refs.rotate1.style.animationPlayState = 'paused';
    },
    playorOrpauseMusic() {
      if (this.audio.playing) {
        this.$refs.audio.pause();
        this.audio.playing = false;
        this.pauseSt();
      } else {
        this.$refs.audio.play();
        this.audio.playing = true;
        this.playSt();
      }
    },
    playMusic() {
      var audios = document.getElementById('audio_music')
      audios.loop = false;
      if (this.startIndex === this.musicAttach.length) {
        this.startIndex = 0;
      }
      audios.src = this.musicAttach[this.startIndex].url
      if (audios.paused === false) {
        audios.play();
      }
      this.startIndex++;
    },
  }
}
</script>

<style scoped>
.musicBox {
  z-index: 99999;
}

.musicImage {
  position: relative;
  padding: 35px 80px;
  animation: animations2 1.5s linear infinite forwards;
}

@keyframes animations2 {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}

.song-img {
  filter:;
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: center center;
  transform: translate(-50%, -50%) rotate(0deg);
  width: 60px;
  height: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border: 0px solid blueviolet;
  border-radius: 200px;
  animation: animations1 4s linear infinite forwards;
  animation-play-state: paused;
  -webkit-user-drag: none;
}

@keyframes animations1 {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  50% {
    transform: translate(-50%, -50%) rotate(180deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

* img, span, a, div {
  user-select: none;
  -webkit-user-drag: none;
}
</style>